import React, { FunctionComponent } from 'react';

import classNames from 'classnames';

import { formatNumber } from '../../utils/formatNumber';

import styles from './PageSection.scss';

export type PageSectionProps = {
  title?: string;
  titleId?: string;
  count?: number;
  titleClass?: string;
  className?: string;
  hasBorder?: boolean;
  hasBottomBorder?: boolean;
  fullWidth?: boolean;
  sectionRef?: React.RefObject<HTMLElement>;
};

export const PageSection: FunctionComponent<PageSectionProps> = ({
  titleClass = 'jg-h2',
  className = '',
  children,
  title,
  count,
  hasBorder,
  fullWidth,
  sectionRef,
  titleId,
  hasBottomBorder,
}) => {
  return (
    <section
      className={classNames(
        styles.pagesSection,
        className,
        { 'jg-bdt jg-bd--very-light-grey': hasBorder },
        { 'jg-bdb jg-bd--very-light-grey': hasBottomBorder },
        { [styles.pagesSectionRestrictWidth]: !fullWidth },
      )}
      ref={sectionRef}
    >
      {title && (
        <header>
          <h1 id={titleId} className={titleClass} tabIndex={-1}>
            {title}
            {typeof count === 'number' && count > 0 && (
              <span data-qa="section-count" className="jg-pull-right">
                {formatNumber(count)}
              </span>
            )}
          </h1>
        </header>
      )}
      {children}
    </section>
  );
};

export default PageSection;
